import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextInput } from '../entities/text-input.entity';

import { SubjectRelay } from '../../../shared/commands/subject-relay.class';

import { Observable } from 'rxjs';

@Component({ template: ''})
export abstract class MultiTextInputComponent {

	@Input() id!: string;

	@Input() label!: string;
	@Input() formGroupClass: string = 'col-sm-12';
	@Input() labelClass: string = 'col-sm-2';
	@Input() fieldClass: string = 'col-sm-6';
	@Input() placeholder: string = '';

	private resetCommandsSubject$ = new SubjectRelay<string[]>();
	@Input() set resetCommand(obs: Observable<string[]> | undefined) {
		this.resetCommandsSubject$.registerSource(obs);
	}
	
	textInputs: TextInput[] = [];

	@Output() valuesChange = new EventEmitter<TextInput[]>();

	constructor() {
		this.init([]);
		this.resetCommandsSubject$.subscribe(
			(resetValues: string[]) => {
				this.init(resetValues);
			}
		);
	}
	
	init(values: string[]) {
		this.textInputs = [];
		if (values.length === 0) {
			values = [''];
		}
		values.forEach(value => {
			let textInput = new TextInput();
			textInput.value = value;
			textInput.isValid = true; // par défaut la vide est présumée valide
			this.textInputs.push(textInput);
		});
	}
	
	onFocusOut(focusEvent: any, index: number) {
		let value = focusEvent['target']['value'];
		if (this.textInputs[index].value !==  value) {
			// value has changed
			this.textInputs[index].value = value;
			// emettre un event pour la synchro avec le parent
			this.valuesChange.emit(this.textInputs);
		}
	}
	
	addInput() {
		this.textInputs.push(new TextInput());
		return false;
	}
	
	removeInput(index: number)	{
		this.textInputs.splice(index, 1);
		// emettre un event pour la synchro avec le parent
		this.valuesChange.emit(this.textInputs);
		return false;
	}

}